<template>
	<div :class="`border-t-1 border-border-color my-${space} w-full`" />
</template>

<script>
	export default {
		name: 'AppLine',
		props: {
			space: {
				type: String,
				default: '2',
			},
		},
	};
</script>
